import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Badge, Spinner, Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import LunchPlanWaiverListComp from '../../../../components/registrationPacket/LunchPlanWaiverListComp';

const LunchPlanWaiverList = () => {
  
  useEffect(() => {
    
  }, []);

  return (
    <Container>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">Lunch Plan Waivers</h4>
              </div>
              <Link to="/dashboard/lunch-plan-waiver/add">
                <Button variant="primary" size="sm">
                  <i className="icon material-symbols-outlined me-1" style={{verticalAlign: 'middle'}}>add</i>
                  Create New Waiver
                </Button>
              </Link>
            </Card.Header>
            <Card.Body>
              <LunchPlanWaiverListComp/>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LunchPlanWaiverList;
